import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { InternalIntegrationSetting } from 'models/InternalIntegrationSetting';
import EditRateMultiplierModal from './EditRateMultiplierModal';

const modalId = 'edit-rate-multiplier-modal';

const useEditRateMultiplierModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openEditRateMultiplierModal = ({
    integrationSettings,
  }: {
    integrationSettings: InternalIntegrationSetting;
  }) => {
    const { name, displayName } = integrationSettings.integration;

    openModal({
      customContent: (
        <EditRateMultiplierModal integrationSettings={integrationSettings} />
      ),
      id: modalId,
      title: t('pageChannels.modals.editRateMultiplier.title', {
        channel: displayName ?? name,
      }),
    });
  };

  return { openEditRateMultiplierModal };
};

export default useEditRateMultiplierModal;
